<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>
    <!-- navegación -->
    <div class="tabs">
      <div :class="{ circle: true, circle_active: 0 <= index_tab }">
        <v-icon dark v-if="index_tab > 0 && readonly == false" @click="selectedTab(0)">fa fa-pencil-alt</v-icon>
        <v-icon dark v-else-if="index_tab > 0 && readonly == true" @click="selectedTab(0)">far fa-eye</v-icon>
        <span v-else>1</span>
      </div>
      <div class="titulo">Principal</div>
      <div class="separador"></div>
      <div :class="{ circle: true, circle_active: 1 <= index_tab }">2</div>
      <div class="titulo">Domicilio</div>
    </div>
    <!-- card de registro familiar -->
    <v-card class="mb-8">
      <v-card-title class="btn_agregar py-2">
        <v-row class="d-flex justify-center">
          <h4>{{ tituloSelected }}</h4>
        </v-row>
      </v-card-title>
      <v-card-text v-show="index_tab === 0">
        <v-container>
          <v-form ref="form_familiar_datos_personales">
            <v-container>
              <v-row>
                <v-col cols="12" md="4" sm="6">
                  <AutocompleteComp textLabel="Parentesco" @change="seleccionarTipoParentesco(idTipoParentesco)"
                    :items="listTipoParentescos" v-model="idTipoParentesco" :rules="validationRules.validateCampo"
                    item-text="desc_tipos_parientes" item-value="id" :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <AutocompleteComp textLabel="Tipo de documento de identidad"
                    @change="changedinamicValidation(idTipoDocumento)" :items="listTipoDocumentos"
                    v-model="idTipoDocumento" :rules="validationRules.validateCampo" item-text="desc_tipo_documento"
                    item-value="id" :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <v-text-field label="Número de documento de identidad" :append-icon="'fa-search'"
                    @click:append="buscarPersona()" @blur="buscarPersona()" v-model="numeroDocumento" type="number"
                    :rules="dinamicValidation" :readonly="readonly" :disabled="perfilEdit" />

                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <textfieldComp textLabel="Nombres" v-model="nombres" :rules="validationRules.validateName"
                    :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <textfieldComp textLabel="Apellido paterno" v-model="apellidoPaterno" type="text"
                    :rules="validationRules.validateCampo" :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <textfieldComp textLabel="Apellido materno" v-model="apellidoMaterno" type="text"
                    :rules="validationRules.validateCampo" :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition"
                    offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="fechaNacimientoFormateada" label="Fecha de nacimiento"
                        :rules="[(v) => !!v || 'Campo requerido']" @blur="
        fechaNacimiento = parseDate(fechaNacimientoFormateada)
        " :readonly="readonly" v-bind="attrs" v-on="readonly ? false : on" @keypress="($event) => {
        return $event.preventDefault();
      }
        "></v-text-field>
                    </template>
                    <v-date-picker v-model="fechaNacimiento" no-title :max="moment().format()" @input="menu = false"
                      scrollable :readonly="readonly">
                      <v-spacer></v-spacer>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <AutocompleteComp textLabel="País de nacimiento" @change="seleccionarPaisNacimiento(idPaisNacimiento)"
                    :items="listPaises" v-model="idPaisNacimiento" :rules="validationRules.validateCampo"
                    item-text="nombre_pais" item-value="id" :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <AutocompleteComp textLabel="Nacionalidad" @change="seleccionarNacionalidad(idNacionalidad)"
                    :items="listNacionalidades" v-model="idNacionalidad" :rules="validationRules.validateCampo"
                    item-text="desc_nacionalidad" item-value="id" :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <AutocompleteComp textLabel="Sexo" @change="seleccionarSexo(idSexo)" :items="listSexos"
                    v-model="idSexo" :rules="validationRules.validateCampo" item-text="descripcion" item-value="id"
                    :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <AutocompleteComp textLabel="Estado civil" @change="seleccionarEstadoCivil(idEstadoCivil)"
                    :items="listEstadoCivil" v-model="idEstadoCivil" :rules="validationRules.validateCampo"
                    item-text="desc_estado_civil" item-value="id" :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <v-checkbox v-model="apoderado" label="Apoderado" :readonly="readonly"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="3">
                  <v-radio-group class="mt-0" v-model="estado_familia" label="Estado">
                    <v-radio label="Activo" :value="1" color="teal"></v-radio>
                    <v-radio label="Inactivo" :value="0" color="error"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>

              <!-- DATOS DE USUARIO PARA EL ALUMNO -->
              <!-- CREDENCIALES DE USUARIO -->

              <v-row>
                <v-col cols="12" sm="12" md="12" class="pb-0">
                  <v-alert dense border="left" class="text-center" color="#0277bd" dark>
                    <h3>CREDENCIALES DE USUARIO</h3>
                  </v-alert>
                </v-col>

                <v-col cols="12" sm="6" md="3" class="py-0">
                  <v-text-field label="Nombre de usuario" type="text" v-model="persona.usu_usuario"
                    disabled></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="3" class="py-0" v-if="this.evento == 'agregar'">
                  <v-text-field v-model="persona.password_usuario" :append-icon="show ? 'fa-eye' : 'fa-eye-slash'"
                    :rules="validationRules.validatePassword" :type="show ? 'text' : 'password'" label="Contraseña"
                    @click:append="show = !show">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0" v-if="!habilitarUsMaster">
                  <v-autocomplete v-model="persona.id_perfil" :items="Perfil" item-text="descripcion_perfil"
                    item-value="id_perfil" @change="cargarLicenciaTipo(persona.id_perfil)"
                    :rules="validationRules.validateCampoList" label="Perfil" :disabled="perfilEdit" auto-select-first>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0" v-if="!habilitarUsMaster">
                  <v-select label="Tipo de licencia" v-model="persona.id_licencia_tipo" :items="LicenciaTipo"
                    item-value="id" item-text="desc_tipo_licencia"
                    :readonly="persona.fecha_fin > new Date().toISOString().substr(0, 10)" disabled>
                  </v-select>
                </v-col>

                <v-col cols="12" sm="6" md="6" class="py-0" v-if="persona.fecha_fin > new Date().toISOString().substr(0, 10)
        ">
                  Licencia
                  <p class="black--text">{{ persona.serie_licencia }}</p>
                </v-col>


                <v-col cols="12" sm="6" md="6" class="py-0" v-else>
                  <v-autocomplete label="Licencias" v-model="persona.id_licencia" :items="Licencia" item-value="id"
                    item-text="serie_licencia" disabled>
                  </v-autocomplete>
                </v-col>

              </v-row>

            </v-container>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-text v-show="index_tab === 1">
        <v-container>
          <v-form ref="form_familiar_ubicacion" @submit.prevent>
            <v-container>
              <v-row>
                <v-col cols="12" md="4" sm="6">
                  <AutocompleteComp textLabel="País" @change="seleccionarPais(idPais)" :items="listPaises"
                    v-model="idPais" :rules="validationRules.validateCampo" item-text="nombre_pais" item-value="id"
                    :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <AutocompleteComp textLabel="Departamento" @change="seleccionarDepartamento(idDepartamento)"
                    :items="listDepartamentos" v-model="idDepartamento" :rules="validationRules.validateCampo"
                    item-text="nombre_ubicacion1" item-value="id" :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <AutocompleteComp textLabel="Provincia" @change="seleccionarProvincia(idProvincia)"
                    :items="listProvincias" v-model="idProvincia" :rules="validationRules.validateCampo"
                    item-text="nombre_ubicacion2" item-value="id" :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <AutocompleteComp textLabel="Distrito" @change="seleccionarDistrito(idDistrito)"
                    :items="listDistritos" v-model="idDistrito" :rules="validationRules.validateCampo"
                    item-text="nombre_ubicacion3" item-value="id" :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="8" sm="12">
                  <textfieldComp textLabel="Dirección" v-model="direccion" :rules="validationRules.validateCampo"
                    :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <textfieldComp textLabel="Teléfono móvil" v-model="celular"
                    :rules="validationRules.validateMovilphone" :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <textfieldComp textLabel="Teléfono fijo" v-model="telefono" :rules="validationRules.validatePhone"
                    :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="6" sm="12">
                  <textfieldComp textLabel="Correo electrónico" v-model="correo" :rules="validationRules.validateCorreo"
                    :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <textfieldComp textLabel="Profesión" v-model="profesion" :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="3" sm="6">
                  <textfieldComp textLabel="Centro de trabajo" v-model="centroTrabajo" :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="6" sm="12">
                  <textfieldComp textLabel="Ocupación" v-model="ocupacion" :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="6" sm="6">
                  <textfieldComp textLabel="Teléfono del trabajo" v-model="telefonoTrabajo"
                    :rules="validationRules.validateChambaphone" :readonly="readonly" />

                </v-col>
                <v-col cols="12" md="6" sm="6">
                  <textfieldComp textLabel="Dirección del trabajo" v-model="direccionTrabajo" :readonly="readonly" />

                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="btn_actions">
        <v-row dense>
          <v-col cols="12" class="d-flex justify-end gap-10px">
            <TableButtonComp normalButton v-if="index_tab === 0" @click="tabNext" textButton="Continuar"
              iconBut="fas fa-arrow-circle-right" />
            <TableButtonComp normalButton v-if="index_tab === 1 && readonly === false" @click="save" :loading="loading"
              :textButton="tituloGuardar" iconBut="fas fa-save" />
            <TableButtonComp normalButton v-if="index_tab === 1" @click="tabBack" textButton="Volver" classColor="red"
              iconBut="fas fa-arrow-circle-left" />

            <TableButtonComp normalButton v-if="index_tab === 0" @click="cancelar" textButton="Cancelar"
              classColor="red" />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
// eslint-disable-next-line
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import axios from "../../../helpers/axios";
import textfieldComp from "@/components/ComponentsEst/textfieldComp.vue";
import AutocompleteComp from "@/components/ComponentsEst/AutocompleteComp.vue";
import TableButtonComp from "@/components/ComponentsEst/TableButtonComp.vue";
import { validationRules } from "@/helpers/validatorHelpers.js";

import moment from "moment";
export default {
  components: {
    textfieldComp,
    AutocompleteComp,
    TableButtonComp,
  },
  data() {
    return {
      readonly: false,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      index_tab: 0,
      titulos: ["DATOS PERSONALES", "DATOS DE UBICACIÓN Y CONTACTO"],
      tituloGuardar: "",
      tituloSelected: "",
      idAlumno: parseInt(this.$route.params.idAlumno),
      idColegio: parseInt(sessionStorage.getItem("id_colegio")),
      idUsuario: parseInt(sessionStorage.getItem("id")),
      idPaisUser: parseInt(sessionStorage.getItem("id_pais")),
      idFamiliar: 0,
      listTipoParentescos: [],
      loading: false,
      listTipoDocumentos: [],
      listSexos: [
        { id: "M", descripcion: "Masculino" },
        { id: "F", descripcion: "Femenino" },
      ],
      listPaises: [],
      listDepartamentos: [],
      listProvincias: [],
      listDistritos: [],
      listNacionalidades: [],
      listEstadoCivil: [],
      defaultPais: 145,
      nombres: "",
      dinamicValidation: [],
      apellidoPaterno: "",
      apellidoMaterno: "",
      idTipoParentesco: "",
      idTipoDocumento: "",
      numeroDocumento: "",
      fechaNacimiento: "",
      fechaNacimientoFormateada: "",
      idSexo: "",
      idPais: "",
      idDepartamento: "",
      idProvincia: "",
      idDistrito: "",
      idEstadoCivil: "",
      idPaisNacimiento: "",
      idNacionalidad: "",
      apoderado: false,
      direccion: "",
      celular: "",
      telefono: "",
      correo: "",
      profesion: "",
      centroTrabajo: "",
      ocupacion: "",
      telefonoTrabajo: "",
      direccionTrabajo: "",
      rules: {
        validarNumeroDocumento: (numDoc) => {
          let msg = "";

          switch (this.idTipoDocumento) {
            case 1:
              if (isNaN(numDoc)) {
                msg = "solo debe tener números";
              } else if (numDoc.length != 8) {
                msg = "solo debe tener 8 dígitos";
              }
              break;

            case 2:
              if (numDoc.length > 15) {
                msg = "debe tener menos de 15 dígitos";
              }
              break;
            case 4:
              if (isNaN(numDoc)) {
                msg = "solo debe tener números";
              } else if (numDoc.length != 11) {
                msg = "solo debe tener 11 dígitos";
              }
              break;
            default:
              msg = "";
          }
          return msg != "" ? msg : true;
        },
      },
      //Variables de credenciales de usuario
      datoLogin: sessionStorage,
      evento: "",
      item: {},
      persona: {},
      show: false,
      password_usuario: "",
      habilitarUsMaster: false,
      Perfil: [],
      TipoDocumentos: [],
      Colegio: [],
      Paises: [],
      Ubicacion1: [],
      perfilFiltered: {},
      userParams: {},
      perfilEdit: false,
      LicenciaTipo: [],
      id_licencia: 0,
      Licencia: [],
      estado_familia: 0,

    };
  },
  created() {
    this.evento = this.$route.query.evento ? this.$route.query.evento : this.$route.params.evento
    this.item = this.$route.query.item ? this.$route.query.item : this.$route.params.item
  },
  mounted() {
    this.tituloSelected = this.titulos[this.index_tab];
    this.dataInitial();
    this.loadMain();

  },
  watch: {
    fechaNacimiento() {
      this.fechaNacimientoFormateada = this.formatDate(this.fechaNacimiento);
    },
    numeroDocumento(newValue) {
      if (this.evento == 'agregar') {
        this.persona.usu_usuario = "";
        this.persona.usu_usuario = `${newValue}-${this.datoLogin.id_colegio}-${this.persona.id_perfil || ""}`
        this.persona.password_usuario = `${newValue}`
        this.persona.id_perfil = "";
      }
    },
  },
  computed: {
    validationRules() {
      return validationRules;
    },
  },

  methods: {
    ...mapActions("login", ["parametroComponente"]),
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    parseDate(dateFormated) {
      if (!dateFormated) return null;
      const [day, month, year] = dateFormated.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    tabNext() {
      if (this.$refs.form_familiar_datos_personales.validate()) {
        this.index_tab++;
        this.tituloSelected = this.titulos[this.index_tab];
        //this.$refs.form_familiar_ubicacion.validate()
      }
    },

    tabBack() {
      if (this.index_tab > 0) {
        this.index_tab--;
        this.tituloSelected = this.titulos[this.index_tab];
      }
    },
    selectedTab(index) {
      this.index_tab = index;
      this.tituloSelected = this.titulos[this.index_tab];
    },

    changedinamicValidation(id) {
      switch (id) {
        case 1:
          this.dinamicValidation = validationRules.validateDni
          break;
        case 2:
          this.dinamicValidation = validationRules.validateDocument
          break;
        case 4:
          this.dinamicValidation = validationRules.validateRuc
          break;

        default:
          break;
      }
    },

    validarTelefono(e) {

      let keyCode = e.keyCode;
      let digito = e.key;
      if (
        isNaN(digito) &&
        keyCode !== 187 &&
        keyCode !== 8 &&
        keyCode !== 37 &&
        keyCode !== 39
      ) {
        return e.preventDefault();
      }
      return true;
    },
    validarSoloNumero($event) {
      if (
        $event.charCode === 0 ||
        /\d/.test(String.fromCharCode($event.charCode))
      ) {
        return true;
      } else {
        $event.preventDefault();
      }
    },

    cancelar() {
      this.$router.push("/registroacademico");
    },
    dataInitial() {
      this.getTipoParentescos();
      this.getTipoDocumentos();
      this.getPaises();
      this.getEstadoCiviles();
      this.idPais = this.defaultPais;
      this.seleccionarPais(this.idPais);

      if (parseInt(this.$route.params.idFamiliar) > 0) {
        this.cargarFamiliar(parseInt(this.$route.params.idFamiliar));
        this.tituloGuardar = "Guardar Cambios";
      } else {
        this.tituloGuardar = "Guardar";
      }

      if (parseInt(this.$route.params.editarFamiliar) == 0) {
        this.readonly = true;
      } else {
        this.readonly = false;
      }
    },

    //  ------- Cargar todos los registros principales al iniciar el componente   --------
    async loadMain() {
      this.limpiarForm();
      // this.filterPerfilByTipoPersonal()
      if (this.evento == "agregar") {
        this.perfilEdit = false;
        this.persona.id_persona = 0;
        this.persona.id = 0;
      }
      // const numdocLength = String(this.persona.numdoc_persona).length;

      // if (numdocLength >= 8 && numdocLength < 9) {
      //   this.persona.id_tipo_documento = 1;
      // } else if (numdocLength >= 9) {
      //   this.persona.id_tipo_documento = 2;
      // }
      if (this.evento == "editar" || this.evento == "ver") {
        this.perfilEdit = true;
        this.getUserCredentialData()
      }

      this.getQueryUsers()
    },

    async limpiarForm() {
      this.persona = {
        id_usuario: this.datoLogin.id,
        id_colegio: this.datoLogin.id_colegio,
        id_pais: this.defaultPais,
        ruta_avatar_persona: null,
        avatar_persona: null,
        ape2_persona: null,
        direc_persona: null,
        correo_persona: null,
        telf_persona: null,
        cel_persona: null,
        evento: null,
        estado_persona: 0,
        estado_usuario: 1,
        id_tipo_usuario: null,
      };
    },

    //////////// Registro de Usuario ////////////////////
    ///////// Evento --> Crear /////////////
    async getQueryUsers() {
      try {
        let response = await axios.get(
          "/sistema/usuario/getQuery/" + this.datoLogin.id_colegio
        );

        this.Colegio = response.data.colegio;
        this.TipoDocumentos = response.data.tipoDocumento;
        // this.Perfil = response.data.perfil;
        let filterPerfil = response.data.rolPerfil.filter(e => ["familiar"].includes(e.desc_rol_licencia));

        this.Perfil = filterPerfil;
        this.Paises = response.data.pais;
        this.Ubicacion1 = response.data.ubicacion1;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async cargarLicenciaTipo(perfil) {

      try {
        this.persona.id_licencia = 0;

        if (!perfil) {
          throw new Error('No se han asignado licencias para el tipo de personal o perfil seleccionado')
        }

        let params = `/sistema/usuario/perfilLicenciaTipo/colegio/${this.datoLogin.id_colegio}/perfil/${perfil}/usuario/${this.datoLogin.id}`;
        let response = await axios.get(params);

        if (!response.data || response.data.length == 0) {
          throw new Error("No se ha asignado ningun tipo de licencia a este perfil");
        }

        this.LicenciaTipo = response.data;

        if (this.evento == 'agregar') {

          this.persona.id_licencia_tipo = this.LicenciaTipo[0].id_licencia_tipo
          // this.persona.usu_usuario = `${this.numeroDocumento}-${this.datoLogin.id_colegio}-${this.persona.id_perfil}`
          this.cargarLicencia();
          if (this.persona.usu_usuario) this.persona.usu_usuario = `${this.numeroDocumento}-${this.persona.id_colegio}-${this.persona.id_perfil}`

        }

      } catch (error) {
        if (error.response) {
          // Si es una respuesta de axios, mostrará información adicional sobre el error
          this.setEnviarMens({ tipo: "E", mensaje: `Error de red: ${error.message}`, tiempo: null });
        } else {
          // Si es una excepción genérica
          this.setEnviarMens({ tipo: "E", mensaje: `${error.message}`, tiempo: null });
        }

        // Lanzar la excepción nuevamente para que otros controladores de errores superiores puedan manejarla si es necesario
        throw error;
      }
    },

    async cargarLicencia() {

      try {

        let params = `/sistema/usuario/licenciaDisponibles/licenciaTipo/${this.persona.id_licencia_tipo}/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`;
        let response = await axios.get(params);


        if (!response.data || !Array.isArray(response.data) || response.data.length === 0) {
          // Si la respuesta no contiene datos o no es un arreglo o está vacío,
          // lanzar una excepción

          this.persona.id_perfil = "";
          this.persona.id_licencia_tipo = "";
          this.$forceUpdate();

          throw new Error('No se encontraron licencias disponibles para este perfil.');

        }

        // Asignar la primera licencia disponible
        this.Licencia = response.data;
        this.persona.id_licencia = this.Licencia[0].id

      } catch (error) {

        if (error.response) {
          // Si es una respuesta de axios, mostrará información adicional sobre el error
          this.setEnviarMens({ tipo: "E", mensaje: `Error de red: ${error.message}`, tiempo: null });
        } else {
          // Si es una excepción genérica
          this.setEnviarMens({ tipo: "E", mensaje: `${error.message}`, tiempo: null });
        }

        // Lanzar la excepción nuevamente para que otros controladores de errores superiores puedan manejarla si es necesario
        throw error;
      }
    },


    ///////////////// Evento ---> Editar //////////////////
    async getUserCredentialData() {
      let userCredentialResult = await axios.get(`/sistema/usuario/userCredential/${this.item.familia.persona.id}`);
      let filteredCredentialResult = userCredentialResult.data.filter(e => e.desc_tipo_licencia == 'Familiar')

      this.perfilEdit = true;
      this.persona.usu_usuario = filteredCredentialResult[0].usu_usuario
      this.persona.fecha_fin = filteredCredentialResult[0].fecha_fin
      this.cargarLicenciaTipo(filteredCredentialResult[0].id_perfil)
      this.persona.id_perfil = filteredCredentialResult[0].id_perfil
      this.persona.serie_licencia = filteredCredentialResult[0].serie_licencia
      this.persona.id_licencia_tipo = filteredCredentialResult[0].id_tipo_licencia;
      this.persona.id_persona = filteredCredentialResult[0].id_persona

    },


    async buscarPersona() {
      if (this.numeroDocumento === "") {
        this.setEnviarMens({
          tipo: "E",
          mensaje: "Debe de ingresar un número de documento.",
          tiempo: null,
        });
      } else {
        let response = await axios.post(
          "/administrativo/alumno/buscarPersona",
          {
            idColegio: this.idColegio,
            numeroDocumento: this.numeroDocumento,
          }
        );

        //Cuando el documento no se encuetra registrado entra aqui
        if (response.data.messageT == "W") {
          //Cuando el documento ya se encuetra asociado a un perfil "estudiante" limpia el campo del formulario
          if (response.data.payload == 1) {
            this.numeroDocumento = ""
          }
          // this.setEnviarMens({
          //   tipo: "W",
          //   mensaje: response.data.message,
          //   tiempo: null,
          // });
          return
        }

        if (response.data.messageT == "S") {

          this.setEnviarMens({
            tipo: "S",
            mensaje: response.data.message,
            tiempo: null,
          });

          let data = response.data.perfiles[0];

          this.idFamiliar = data.id ? data.id : 0;
          this.idTipoDocumento = data.id_tipo_documento;
          this.nombres = data.nombre_persona;
          this.apellidoPaterno = data.ape1_persona;
          this.apellidoMaterno = data.ape2_persona;
          this.fechaNacimiento = data.fecnac_persona;
          this.idPaisNacimiento = data.id_pais_nacimiento;
          this.idNacionalidad = data.id_nacionalidad;
          if (data.id_nacionalidad > 0) {
            this.getNacionalidades();
          }
          this.idSexo = data.sexo_persona;
          this.idEstadoCivil = data.id_estado_civil;
          this.idPais = data.id_pais;
          this.idDepartamento = data.id_ubicacion1;
          if (data.id_ubicacion1 > 0) {
            this.getDepartamentos();
          }
          this.idProvincia = data.id_ubicacion2;
          if (data.id_ubicacion2 > 0) {
            this.getProvincias();
          }
          this.idDistrito = data.id_ubicacion3;
          if (data.id_ubicacion3 > 0) {
            this.getDistritos();
          }
          this.direccion = data.direc_persona;
          this.celular = data.cel_persona;
          this.telefono = data.telf_persona;
          this.correo = data.correo_persona;
          this.profesion = data.profesion_familia;
          this.centroTrabajo = data.centro_trabajo;
          this.ocupacion = data.ocupacion_familia;
          this.telefonoTrabajo = data.telefono_trabajo;
          this.direccionTrabajo = data.direccion_trabajo;
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    async cargarFamiliar(idFamiliar) {

      try {
        this.idFamiliar = parseInt(this.$route.params.idFamiliar);
        this.idAlumno = parseInt(this.$route.params.idAlumno);

        let response = await axios.post("/administrativo/alumno/getFamiliar", {
          idColegio: this.idColegio,
          idFamiliar: this.idFamiliar,
          idAlumno: this.idAlumno,
        });

        response = response.data;


        let payload = response.payload;

        this.idTipoParentesco = payload.id_tipo_parentesco;
        this.idTipoDocumento = payload.familia.persona.id_tipo_documento;
        this.numeroDocumento = payload.familia.persona.numdoc_persona;
        this.nombres = payload.familia.persona.nombre_persona;
        this.apellidoPaterno = payload.familia.persona.ape1_persona;
        this.apellidoMaterno = payload.familia.persona.ape2_persona;
        this.fechaNacimiento = payload.familia.persona.fecnac_persona;
        this.idPaisNacimiento = payload.familia.persona.id_pais_nacimiento;
        this.idNacionalidad = payload.familia.persona.id_nacionalidad;
        this.idSexo = payload.familia.persona.sexo_persona;
        this.idEstadoCivil = payload.familia.id_estado_civil;
        this.apoderado = payload.es_encargado === 1 ? true : false;
        this.idPais = payload.familia.persona.id_pais;
        this.idDepartamento = payload.familia.persona.id_ubicacion1;
        this.idProvincia = payload.familia.persona.id_ubicacion2;
        this.idDistrito = payload.familia.persona.id_ubicacion3;
        this.direccion = payload.familia.persona.direc_persona;
        this.celular = payload.familia.persona.cel_persona;
        this.telefono = payload.familia.persona.telf_persona;
        this.correo = payload.familia.persona.correo_persona;
        this.profesion = payload.familia.profesion_familia;
        this.centroTrabajo = payload.familia.centro_trabajo;
        this.ocupacion = payload.familia.ocupacion_familia;
        this.telefonoTrabajo = payload.familia.telefono_trabajo;
        this.direccionTrabajo = payload.familia.direccion_trabajo;
        this.estado_familia = payload.familia.estado_familia

        this.getNacionalidades();
        this.getDepartamentos();
        this.getProvincias();
        this.getDistritos();
      } catch (e) {

        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar datos del familiar`,
          tiempo: null,
        });
      }
    },
    async getTipoParentescos() {
      try {
        let response = await axios.post(
          "/administrativo/alumno/getTipoParentescos",
          {
            idColegio: this.idColegio,
            idPais: this.idPaisUser,
          }
        );

        response = response.data;

        if (response.messageT === "S") {
          this.listTipoParentescos = response.payload;
        }
      } catch (e) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar lista de parentescos`,
          tiempo: null,
        });
      }
    },
    async getTipoDocumentos() {
      try {
        let response = await axios.post(
          "/administrativo/alumno/getTipoDocumentos",
          {
            idColegio: this.idColegio,
            idPais: this.idPaisUser,
          }
        );

        response = response.data;

        if (response.messageT === "S") {
          this.listTipoDocumentos = response.payload;
        }
      } catch (e) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar lista de documentos`,
          tiempo: null,
        });
      }
    },
    async getPaises() {
      try {
        let response = await axios.post("/administrativo/alumno/getPaises", {
          idColegio: this.idColegio,
        });

        response = response.data;

        if (response.messageT === "S") {
          this.listPaises = response.payload;
        }
      } catch (e) {

        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar lista de países`,
          tiempo: null,
        });
      }
    },
    async getNacionalidades() {
      try {
        let response = await axios.post(
          "/administrativo/alumno/getNacionalidades",
          {
            idColegio: this.idColegio,
            idPais: this.idPaisNacimiento,
          }
        );

        response = response.data;

        if (response.messageT === "S") {
          this.listNacionalidades = response.payload;
        }
      } catch (e) {

        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar lista de nacionalidades`,
          tiempo: null,
        });
      }
    },
    async getEstadoCiviles() {
      try {
        let response = await axios.post(
          "/administrativo/alumno/getEstadosCiviles",
          {
            idColegio: this.idColegio,
            idPais: this.idPais,
          }
        );

        response = response.data;

        if (response.messageT === "S") {
          this.listEstadoCivil = response.payload;
        }
      } catch (e) {

        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar lista de estado civil`,
          tiempo: null,
        });
      }
    },
    async getDepartamentos() {
      try {
        let response = await axios.post(
          "/administrativo/alumno/getDepartamentos",
          {
            idColegio: this.idColegio,
            idPais: this.idPais,
          }
        );

        response = response.data;

        if (response.messageT === "S") {
          this.listDepartamentos = response.payload;
        }
      } catch (e) {

        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar lista de departamentos`,
          tiempo: null,
        });
      }
    },
    async getProvincias() {
      try {
        let response = await axios.post(
          "/administrativo/alumno/getProvincias",
          {
            idColegio: this.idColegio,
            idPais: this.idPais,
            idDepartamento: this.idDepartamento,
          }
        );

        response = response.data;

        if (response.messageT === "S") {
          this.listProvincias = response.payload;
        }
      } catch (e) {

        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar lista de provincias`,
          tiempo: null,
        });
      }
    },
    async getDistritos() {
      try {
        let response = await axios.post("/administrativo/alumno/getDistritos", {
          idColegio: this.idColegio,
          idPais: this.idPais,
          idDepartamento: this.idDepartamento,
          idProvincia: this.idProvincia,
        });

        response = response.data;

        if (response.messageT === "S") {
          this.listDistritos = response.payload;
        }
      } catch (e) {

        this.setEnviarMens({
          tipo: "E",
          mensaje: `No se pudo cargar lista de distrito`,
          tiempo: null,
        });
      }
    },
    /**eventos */
    seleccionarTipoParentesco(idTipoParentesco) {
      let tipoParen = this.listTipoParentescos.find(tip => tip.id == idTipoParentesco);

      if (tipoParen && (tipoParen.desc_tipos_parientes.includes("HERMANO") || tipoParen.desc_tipos_parientes.includes("PRIMO"))) {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `En caso el hermano o primo sea un estudiante, registrar por matrícula del estudiante. Si se registra como familiar no se podrá asignar como estudiante`,
          tiempo: 5000,
        });
      }
      this.idTipoParentesco = idTipoParentesco;
    },
    seleccionarTipoDocumento(idTipoDocumento) {
      this.idTipoDocumento = idTipoDocumento;
      this.$refs.refNumeroDocumento.validate();
    },
    seleccionarSexo(idSexo) {
      this.idSexo = idSexo;
    },
    seleccionarEstadoCivil(idEstadoCivil) {
      this.idEstadoCivil = idEstadoCivil;
    },
    seleccionarPaisNacimiento(idPaisNacimiento) {
      this.idPaisNacimiento = idPaisNacimiento;
      this.getNacionalidades();
    },
    seleccionarNacionalidad(idNacionalidad) {
      this.idNacionalidad = idNacionalidad;
    },
    seleccionarPais(idPais) {
      this.idPais = idPais;
      this.getDepartamentos();
    },
    seleccionarDepartamento(idDepartamento) {
      this.idDepartamento = idDepartamento;
      this.getProvincias();
    },
    seleccionarProvincia(idProvincia) {
      this.idProvincia = idProvincia;
      this.getDistritos();
    },
    seleccionarDistrito(idDistrito) {
      this.idDistrito = idDistrito;
    },
    async save() {
      this.loading = true;
      try {
        if (this.$refs.form_familiar_ubicacion.validate()) {
          let dataRequest = {
            idColegio: this.idColegio,
            idAlumno: this.idAlumno,
            idFamiliar: this.idFamiliar,
            nombres: this.nombres,
            apellidoPaterno: this.apellidoPaterno,
            apellidoMaterno: this.apellidoMaterno,
            numeroDocumento: this.numeroDocumento,
            idUsuario: this.idUsuario,
            direccion: this.direccion,
            idTipoDocumento: this.idTipoDocumento,
            idPaisNacimiento: this.idPaisNacimiento,
            idNacionalidad: this.idNacionalidad,
            idPais: this.idPais,
            idDepartamento: this.idDepartamento,
            idProvincia: this.idProvincia,
            idDistrito: this.idDistrito,
            fechaNacimiento: this.fechaNacimiento,
            sexo: this.idSexo,
            idTipoPariente: this.idTipoParentesco,
            telefono: this.telefono,
            celular: this.celular,
            correo: this.correo,
            //observacionDomicilio: this.observacionDomicilio,
            telefonoTrabajo: this.telefonoTrabajo,
            profesionFamilia: this.profesion,
            centroTrabajo: this.centroTrabajo,
            ocupacionFamilia: this.ocupacion,
            direccionTrabajo: this.direccionTrabajo,
            idEstadoCivil: this.idEstadoCivil,
            esEncargado: this.apoderado ? 1 : 0,
            estado_familia: this.estado_familia,
          };


          this.persona.evento = this.evento;
          this.persona.nombre_persona = this.nombres;
          this.persona.id = this.idAlumno;//
          this.persona.ape1_persona = this.apellidoPaterno;
          this.persona.ape2_persona = this.apellidoMaterno;
          this.persona.id_tipo_documento = this.idTipoDocumento;
          this.persona.numdoc_persona = this.numeroDocumento;
          this.persona.correo_persona = this.correo;
          this.persona.id_ubicacion1 = this.idDepartamento;
          this.persona.id_ubicacion2 = this.idProvincia;
          this.persona.id_ubicacion3 = this.idDistrito;
          this.persona.direc_persona = this.direccion;
          this.persona.telf_persona = this.telefono;
          this.persona.cel_persona = this.celular;
          this.persona.sexo_persona = this.idSexo;
          this.persona.fecnac_persona = this.fechaNacimiento;
          this.persona.id_pais_nacimiento = this.idPaisNacimiento;
          this.persona.id_nacionalidad = this.idNacionalidad;


          ////////////// CREAR FAMILIAR //////////////////

          let response = await axios.post(
            "/administrativo/alumno/registrarFamiliar",
            dataRequest
          );

          response = response.data;

          this.setEnviarMens({
            tipo: response.messageT,
            mensaje: response.message,
            tiempo: null,
          });
          console.log("antes")
          if (response.messageT === "S") {

            ////////  CREAR USUARIOS REQUEST ////////////////
            console.log(this.persona)
            if (this.evento == 'agregar') {
              let { data } = await axios.post("/sistema/usuario/", this.persona);

              if (data.success) {

                this.setEnviarMens({
                  tipo: data.messageT,
                  mensaje: data.message,
                  tiempo: "null",
                });

              } else {
                this.setEnviarMens({
                  tipo: data.messageT,
                  mensaje: data.message,
                  tiempo: "null",
                });
              }

              this.perfilEdit = false;
              if (data.error) return
            }

            setTimeout(() => {
              this.$router.push("/registroacademico");
            }, 900);
          }
        }
      } catch (e) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Ups! no se pudo guardar, por favor intente de nuevo.`,
          tiempo: null,
        });
      } finally {
        this.loading = false;
      }
    },
    moment() {
      return moment();
    },
  },
};
</script>
<style>
.tabs {
  width: 100%;
  height: 60;
  padding: 10px;
  display: flex;
  align-items: center;
}

.circle {
  width: 40px;
  height: 40px;
  background: #caccd1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 50%;
  margin: 0 10px 0;
}

.circle_active {
  background: #0277bd;
}

.titulo {
  margin: 0 10px 0 0;
}

.separador {
  width: 60px;
  border: 1px solid #caccd1;
  background: #caccd1;
}
</style>
